import { render, staticRenderFns } from "./trainMap.vue?vue&type=template&id=0b1131f4&scoped=true&"
import script from "./trainMap.vue?vue&type=script&lang=ts&"
export * from "./trainMap.vue?vue&type=script&lang=ts&"
import style0 from "./trainMap.vue?vue&type=style&index=0&id=0b1131f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1131f4",
  null
  
)

export default component.exports